/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_FilmstripInputs */

const en_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Film Strip`)
};

const fr_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher la pellicule`)
};

const de_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filmstreifen zeigen`)
};

const it_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra la striscia di pellicola`)
};

const ru_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать кинопленку`)
};

const es_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar tira de película`)
};

const zh_cn2_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放映胶片`)
};

const ja_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルムストリップを表示`)
};

const hi_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिल्म स्ट्रिप दिखाएँ`)
};

const pt_pt2_options_editor_show_filmstrip = /** @type {(inputs: Options_Editor_Show_FilmstripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir tira de filme`)
};

/**
* | output |
* | --- |
* | "Show Film Strip" |
*
* @param {Options_Editor_Show_FilmstripInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_filmstrip = /** @type {((inputs?: Options_Editor_Show_FilmstripInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_FilmstripInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_show_filmstrip(inputs)
	if (locale === "de") return de_options_editor_show_filmstrip(inputs)
	if (locale === "it") return it_options_editor_show_filmstrip(inputs)
	if (locale === "ru") return ru_options_editor_show_filmstrip(inputs)
	if (locale === "es") return es_options_editor_show_filmstrip(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_show_filmstrip(inputs)
	if (locale === "ja") return ja_options_editor_show_filmstrip(inputs)
	if (locale === "hi") return hi_options_editor_show_filmstrip(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_show_filmstrip(inputs)
	return en_options_editor_show_filmstrip(inputs)
});